var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "global-side-menu", class: { open: _vm.isOpen } },
    [
      _c("transition", { attrs: { name: "overlay" } }, [
        _vm.isOpen
          ? _c("div", { staticClass: "overlay", on: { click: _vm.close } })
          : _vm._e(),
      ]),
      _c("transition", { attrs: { name: "drawer" } }, [
        _vm.isOpen
          ? _c(
              "aside",
              {
                staticClass: "drawer",
                attrs: {
                  role: "dialog",
                  "aria-modal": "true",
                  "aria-label": _vm.$t("globalSideMenu.ariaOpen"),
                },
              },
              [
                _c("nav", { staticClass: "drawer-body" }, [
                  _c(
                    "section",
                    { staticClass: "menu-section" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "menu-item",
                          class: { active: _vm.isActiveRoute("home") },
                          attrs: { to: { name: "home" } },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.close.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "menu-icon",
                            attrs: { src: _vm.icons.home, alt: "" },
                          }),
                          _c("span", { staticClass: "menu-label" }, [
                            _vm._v(_vm._s(_vm.$t("globalSideMenu.home"))),
                          ]),
                        ]
                      ),
                      !_vm.isSpScreen
                        ? _c(
                            "button",
                            {
                              staticClass: "menu-item menu-item-button",
                              attrs: { type: "button" },
                              on: { click: _vm.onClickNolaNovel },
                            },
                            [
                              _c("img", {
                                staticClass: "menu-icon",
                                attrs: { src: _vm.icons.nolaNovel, alt: "" },
                              }),
                              _c("span", { staticClass: "menu-label" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("globalSideMenu.nolaNovel"))
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      !_vm.isSpScreen && _vm.isFreePlan
                        ? _c(
                            "router-link",
                            {
                              staticClass: "menu-item",
                              class: {
                                active: _vm.isActiveRoute(
                                  "subscriptionAnnounce"
                                ),
                              },
                              attrs: { to: { name: "subscriptionAnnounce" } },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.close.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "menu-icon premium-icon",
                                attrs: { src: _vm.icons.premium, alt: "" },
                              }),
                              _c("span", { staticClass: "menu-label" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("globalSideMenu.premium"))
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("hr", { staticClass: "divider" }),
                  _c(
                    "section",
                    { staticClass: "menu-section" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "menu-item",
                          class: { active: _vm.isActiveRoute("novelCreate") },
                          attrs: { to: { name: "novelCreate" } },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.close.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "menu-icon",
                            attrs: { src: _vm.icons.novelCreate, alt: "" },
                          }),
                          _c("span", { staticClass: "menu-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("globalSideMenu.novelCreate"))
                            ),
                          ]),
                        ]
                      ),
                      !_vm.isSpScreen
                        ? _c(
                            "router-link",
                            {
                              staticClass: "menu-item",
                              class: { active: _vm.isActiveRoute("nolaNovel") },
                              attrs: { to: { name: "nolaNovel" } },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.close.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "menu-icon",
                                attrs: { src: _vm.icons.submit, alt: "" },
                              }),
                              _c("span", { staticClass: "menu-label" }, [
                                _vm._v(_vm._s(_vm.$t("globalSideMenu.submit"))),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      !_vm.isSpScreen
                        ? _c(
                            "router-link",
                            {
                              staticClass: "menu-item",
                              class: { active: _vm.isActiveRoute("memo") },
                              attrs: { to: { name: "memo" } },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.close.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "menu-icon",
                                attrs: { src: _vm.icons.creativeMemo, alt: "" },
                              }),
                              _c("span", { staticClass: "menu-label" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("globalSideMenu.creativeMemo"))
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      !_vm.isSpScreen
                        ? _c(
                            "router-link",
                            {
                              staticClass: "menu-item",
                              class: { active: _vm.isActiveRoute("agent") },
                              attrs: { to: { name: "agent" } },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.close.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "menu-icon",
                                attrs: { src: _vm.icons.agent, alt: "" },
                              }),
                              _c("span", { staticClass: "menu-label" }, [
                                _vm._v(_vm._s(_vm.$t("globalSideMenu.agent"))),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      !_vm.isSpScreen
                        ? _c(
                            "router-link",
                            {
                              staticClass: "menu-item",
                              class: {
                                active: _vm.isActiveRoute("eventContest"),
                              },
                              attrs: { to: { name: "eventContest" } },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.close.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "menu-icon",
                                attrs: { src: _vm.icons.contest, alt: "" },
                              }),
                              _c("span", { staticClass: "menu-label" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("globalSideMenu.contest"))
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      !_vm.isSpScreen
                        ? _c(
                            "router-link",
                            {
                              staticClass: "menu-item",
                              class: {
                                active: _vm.isActiveRoute("eventCompany"),
                              },
                              attrs: { to: { name: "eventCompany" } },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.close.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "menu-icon",
                                attrs: { src: _vm.icons.editorBoard, alt: "" },
                              }),
                              _c("span", { staticClass: "menu-label" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("globalSideMenu.editorBoard"))
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "router-link",
                        {
                          staticClass: "menu-item",
                          class: { active: _vm.isActiveRoute("knowhow") },
                          attrs: { to: { name: "knowhow" } },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.close.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "menu-icon",
                            attrs: { src: _vm.icons.learning, alt: "" },
                          }),
                          _c("span", { staticClass: "menu-label" }, [
                            _vm._v(_vm._s(_vm.$t("globalSideMenu.learning"))),
                          ]),
                        ]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "menu-item",
                          class: {
                            active: _vm.isActiveRoute("assistantCatHome"),
                          },
                          attrs: { to: { name: "assistantCatHome" } },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.onClickAssistantCat.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "menu-icon",
                            attrs: { src: _vm.icons.assistantCat, alt: "" },
                          }),
                          _c("span", { staticClass: "menu-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("globalSideMenu.assistantCat"))
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("hr", { staticClass: "divider" }),
                  _c(
                    "section",
                    { staticClass: "menu-section" },
                    [
                      !_vm.isSpScreen && !_vm.isFreePlan
                        ? _c(
                            "a",
                            {
                              staticClass: "menu-item",
                              attrs: {
                                href: _vm.desktopAppUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                              on: { click: _vm.onClickDesktopApp },
                            },
                            [
                              _c("img", {
                                staticClass: "menu-icon",
                                attrs: { src: _vm.icons.desktopApp, alt: "" },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "menu-label menu-label-with-new",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("globalSideMenu.desktopApp")
                                      ) +
                                      " "
                                  ),
                                  _c("span", { staticClass: "menu-new" }, [
                                    _vm._v("new"),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "router-link",
                        {
                          staticClass: "menu-item",
                          class: { active: _vm.isActiveRoute("news") },
                          attrs: { to: { name: "news" } },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.close.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "menu-icon",
                            attrs: { src: _vm.icons.news, alt: "" },
                          }),
                          _c("span", { staticClass: "menu-label" }, [
                            _vm._v(_vm._s(_vm.$t("globalSideMenu.news"))),
                          ]),
                        ]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "menu-item",
                          class: { active: _vm.isActiveRoute("inbox") },
                          attrs: { to: "/inbox" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.close.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "menu-icon",
                            attrs: { src: _vm.icons.inbox, alt: "" },
                          }),
                          _c("span", { staticClass: "menu-label" }, [
                            _vm._v(_vm._s(_vm.$t("globalSideMenu.inbox"))),
                          ]),
                        ]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "menu-item",
                          class: { active: _vm.isActiveRoute("myPage") },
                          attrs: { to: { name: "myPage" } },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.close.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "menu-icon",
                            attrs: { src: _vm.icons.myPage, alt: "" },
                          }),
                          _c("span", { staticClass: "menu-label" }, [
                            _vm._v(_vm._s(_vm.$t("globalSideMenu.myPage"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("hr", { staticClass: "divider" }),
                  _c("section", { staticClass: "menu-section" }, [
                    _c(
                      "button",
                      {
                        staticClass: "menu-item menu-item-button",
                        attrs: { type: "button" },
                        on: { click: _vm.onClickLogout },
                      },
                      [
                        _c("span", { staticClass: "menu-label" }, [
                          _vm._v(_vm._s(_vm.$t("globalSideMenu.logout"))),
                        ]),
                      ]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "menu-item",
                        attrs: {
                          href: _vm.helpUrl,
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                        on: { click: _vm.close },
                      },
                      [
                        _c("span", { staticClass: "menu-label" }, [
                          _vm._v(_vm._s(_vm.$t("globalSideMenu.help"))),
                        ]),
                      ]
                    ),
                  ]),
                  _c("section", { staticClass: "menu-section small-links" }, [
                    _c(
                      "div",
                      { staticClass: "small-links-row" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "small-link",
                            attrs: { to: { name: "terms" }, target: "_blank" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.close.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("common.termsOfService")) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "router-link",
                          {
                            staticClass: "small-link",
                            attrs: {
                              to: { name: "privacy" },
                              target: "_blank",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.close.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("common.privacyPolicy")) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "small-links-row" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "small-link",
                            attrs: {
                              to: {
                                name: "specifiedCommercialTransactionsAct",
                              },
                              target: "_blank",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.close.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "common.specifiedCommercialTransactionsAct"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "router-link",
                          {
                            staticClass: "small-link",
                            attrs: {
                              to: { name: "paymentServicesAct" },
                              target: "_blank",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.close.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("common.paymentServicesAct")) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "small-links-row" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "small-link",
                            attrs: { to: { name: "contact" } },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.close.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("common.contact")) + " ")]
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "small-link",
                            attrs: {
                              href: "https://indent.co.jp/",
                              target: "_blank",
                              rel: "noopener noreferrer",
                            },
                            on: { click: _vm.close },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("common.companyInfo")) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }